/*==============================
*
* PRODUIT
*
==============================*/

/*======
LIBRARY
======*/
global.Dropzone = require('dropzone');

/* OWL CAROUSEL FOR SLIDER */
require('owl.carousel');

/* magnify */
require('magnify');

/* leaflet maps */
require('leaflet');

require('./partials/btn-mail-tel');

/*======
PAGES
======*/
require('./pages/produit');
require('./pages/categorie');

/*======
GESTION MODALES 
======*/

require('./partials/modal-contact-magasin.js');